import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { message } from "antd";
import { getToken } from "../../utils/getToken";

export const useUpdateOrderMutationCopy = ({
  id,
  payload,
  handleSuccess,
}: {
  id: string;
  payload: any;
  handleSuccess: any;
}) => {
  const token = getToken();

  return useMutation({
    mutationFn: () =>
      axiosInstance
        .patch(`/orders/${id}/accept`, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => res.data),
    onSuccess: async (data) => {
      message.success(data?.message);
      handleSuccess();
    },
    onError: (error: any) => {
      message.error(
        error?.response?.data?.message ||
          `Failed to update the order. Please try again.`
      );
    },
  });
};
